import { useLocation } from "react-router-dom";

interface Props {
  title: string;
  stage: number;
}

/** A screen not yet ported. It says so, and where the same screen still lives
 * on the server, so nobody is stranded while the port is under way. Removed
 * screen by screen as the stages land. */
export default function Placeholder({ title, stage }: Props) {
  const location = useLocation();
  return (
    <section className="app-order">
      <div className="order-head">
        <h2>{title}</h2>
      </div>
      <p className="derived">
        This screen is ported in stage {stage} of the React front end. Until then it is
        served by the application itself at{" "}
        <a href={location.pathname + location.search}>{location.pathname}</a>.
      </p>
    </section>
  );
}

export function NotFound() {
  return (
    <section className="app-order">
      <div className="order-head">
        <h2>Not found</h2>
      </div>
      <p className="derived">There is no screen at this address.</p>
    </section>
  );
}
